/**
 * BOGOS URL param helpers for Ambrosia buy-box sections.
 * On first page load, missing params trigger a full reload so BOGOS can read them.
 * Before checkout, params are merged via replaceState only (no reload).
 */
(function initAmbrosiaBogoUrlParams() {
  'use strict';

  var RELOAD_MARKER = '_amb_bogo_reload';

  function normalizeBogoParamString(rawValue) {
    if (!rawValue) return '';
    var normalized = String(rawValue).trim();
    if (!normalized) return '';

    if (normalized.indexOf('://') !== -1) {
      try {
        normalized = new URL(normalized).search.replace(/^\?/, '');
      } catch (err) {}
    }

    var queryStartIndex = normalized.indexOf('?');
    if (queryStartIndex > -1) {
      normalized = normalized.slice(queryStartIndex + 1);
    }

    normalized = normalized.replace(/^[?&]+/, '');

    var hashIndex = normalized.indexOf('#');
    if (hashIndex > -1) {
      normalized = normalized.slice(0, hashIndex);
    }

    return normalized.trim();
  }

  function isInternalParam(key) {
    return key === RELOAD_MARKER;
  }

  function configuredParamsMatchUrl(sanitizedParams) {
    var incoming = new URLSearchParams(sanitizedParams);
    var current = new URLSearchParams(window.location.search);
    var matches = true;

    incoming.forEach(function (value, key) {
      if (!key) return;
      if (current.get(key) !== value) {
        matches = false;
      }
    });

    return matches;
  }

  function mergeParamsIntoUrl(baseUrl, sanitizedParams) {
    var mergedUrl = new URL(baseUrl, window.location.origin);
    var incomingParams = new URLSearchParams(sanitizedParams);
    var hasValidParam = false;

    incomingParams.forEach(function (value, key) {
      if (!key) return;
      mergedUrl.searchParams.set(key, value);
      hasValidParam = true;
    });

    return hasValidParam ? mergedUrl : null;
  }

  function stripInternalParamsFromCurrentUrl() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has(RELOAD_MARKER)) return;

    url.searchParams.delete(RELOAD_MARKER);
    var nextRelativeUrl = url.pathname + (url.search ? url.search : '') + url.hash;
    window.history.replaceState({}, '', nextRelativeUrl);
  }

  function copyPublicSearchParams(sourceParams, targetUrl) {
    sourceParams.forEach(function (value, key) {
      if (!key || isInternalParam(key)) return;
      targetUrl.searchParams.set(key, value);
    });
  }

  /**
   * @param {{ bogoUrlParamsEnabled?: boolean, bogoUrlParams?: string }} sectionConfig
   * @param {{ allowReload?: boolean }} options
   * @returns {boolean} true when a full-page reload was triggered
   */
  function apply(sectionConfig, options) {
    var allowReload = !!(options && options.allowReload);
    if (!sectionConfig || !sectionConfig.bogoUrlParamsEnabled) return false;

    var sanitizedParams = normalizeBogoParamString(sectionConfig.bogoUrlParams);
    if (!sanitizedParams) return false;

    if (configuredParamsMatchUrl(sanitizedParams)) {
      stripInternalParamsFromCurrentUrl();
      return false;
    }

    var mergedUrl = mergeParamsIntoUrl(window.location.href, sanitizedParams);
    if (!mergedUrl) return false;

    if (allowReload) {
      var currentUrl = new URL(window.location.href);
      if (!currentUrl.searchParams.has(RELOAD_MARKER)) {
        mergedUrl.searchParams.set(RELOAD_MARKER, '1');
        window.location.replace(mergedUrl.toString());
        return true;
      }
    }

    var nextRelativeUrl =
      mergedUrl.pathname + (mergedUrl.search ? mergedUrl.search : '') + mergedUrl.hash;
    window.history.replaceState({}, '', nextRelativeUrl);
    return false;
  }

  window.AmbrosiaBogoUrlParams = {
    normalize: normalizeBogoParamString,
    apply: apply,
    copyPublicSearchParams: copyPublicSearchParams,
    isInternalParam: isInternalParam,
  };
})();
